// Verified 2019 MGIA project photos, with company corner logos removed at Kevin's request.
// Original photo/source mapping remains in awards-evidence.json and the internal cleanup manifest.
export const awardProjects = [
  {
    "id": "northville",
    "location": "Northville",
    "year": 2019,
    "image": "https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/northville-logo-cleaned-20261029.png",
    "alt": "Northville residential landscape — natural stone steps and stepping-stone path connect a patio beside a wooded home",
    "awards": [
      {
        "title": "MGIA Bronze Award",
        "category": "Residential Landscape Re-Construction"
      }
    ],
    "source": "https://www.daalexander.com/18m8/awards/awards-2019/1-mgia-bronze-award-for-residential-landscape-re-construction-100-000-250-000.html"
  },
  {
    "id": "canton",
    "location": "Canton",
    "year": 2019,
    "image": "https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/canton-logo-cleaned-20261029.png",
    "alt": "Canton residential landscape — paver entry walk with seating and layered planting beds at a brick-front home",
    "awards": [
      {
        "title": "MGIA Silver Award",
        "category": "Residential Landscape Construction"
      }
    ],
    "source": "https://www.daalexander.com/18m8/awards/awards-2019/2-mgia-silver-award-for-residential-landscape-construction-100-000-250-000.html"
  },
  {
    "id": "plymouth",
    "location": "Plymouth",
    "year": 2019,
    "image": "https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/plymouth-logo-cleaned-20261029.png",
    "alt": "Plymouth residential landscape — woodland residential garden with hydrangeas, hostas and mature trees",
    "awards": [
      {
        "title": "MGIA Bronze Award",
        "category": "Residential Landscape Re-Construction"
      }
    ],
    "source": "https://www.daalexander.com/18m8/awards/awards-2019/3-mgia-bronze-award-for-residential-landscape-re-construction-25-000-50-000.html"
  }
];
